import { Controller } from "@hotwired/stimulus"
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import 'tippy.js/themes/light-border.css';
import { updateContext } from "util/context";
const classes = require("util/classes")(__filename)

const isVisible = el => el.offsetParent !== null
const isFirstCardOnPage = el => el === document.querySelector(`.${classes("container")}`)

export default class extends Controller {
  static targets = ["variant", "swatch", "quickAdd", "hiddenPriceContent", "hiddenPriceTooltip"]

  tooltipShowTimeout = null

  connect() {
    this.currentVariantId = this.variantTargets[0].dataset.variantId
    this.showCurrentVariant()

    this.quickAddTargets.forEach(quickAdd => {
      const tooltip = tippy(quickAdd, {
        theme: "light-border",
        placement: "bottom-end",
        hideOnClick: false,
        content: "Add to My Try-on",
        zIndex: 2,
        onCreate: (instance) => instance.popper.classList.add(classes("quick-add-tooltip"))
      })

      if (this.showQuickAddTooltip(quickAdd)) {
        this.tooltipShowTimeout = setTimeout(() => { tooltip.show() }, 1000)
        this.hideTooltipWhenContainerScrolls(tooltip)
      }
    })

    if (this.hasHiddenPriceTooltipTarget) {
      this.hiddenPriceContentTargets.forEach(hiddenPriceContent => {
        tippy(hiddenPriceContent, {
          theme: "light-border",
          placement: "top",
          hideOnClick: false,
          content: this.hiddenPriceTooltipTarget.innerHTML,
          allowHTML: true,
          interactive: true,
        })
      })
    }
  }

  disconnect() {
    if (this.tooltipShowTimeout) {
      clearTimeout(this.tooltipShowTimeout)
    }
    this.removeContainerScrollListener?.()
  }

  // Hide the hint as soon as a scrolling container holding this card (e.g. a
  // collection carousel) starts to scroll. Scroll events don't bubble, so
  // listen in the capture phase.
  hideTooltipWhenContainerScrolls(tooltip) {
    const onScroll = (event) => {
      if (!(event.target instanceof Element) || !event.target.contains(this.element)) return

      clearTimeout(this.tooltipShowTimeout)
      tooltip.setProps({ duration: [null, 0] })
      tooltip.hide()
      this.removeContainerScrollListener()
    }

    document.addEventListener("scroll", onScroll, { capture: true, passive: true })
    this.removeContainerScrollListener = () => document.removeEventListener("scroll", onScroll, { capture: true })
  }

  onSwatchClick(event) {
    const { variantId } = event.currentTarget.dataset;
    this.currentVariantId = variantId;
    this.showCurrentVariant()
  }

  showCurrentVariant() {
    this.toggleCurrent(this.variantTargets)
    this.toggleCurrent(this.swatchTargets)
    this.toggleCurrent(this.quickAddTargets)
  }

  toggleCurrent(els) {
    els.forEach(el => {
      el.classList.toggle(classes("current"), el.dataset.variantId === this.currentVariantId)
    });
  }

  onQuickAddClick() {
    updateContext(this, "restoreFocusTo", this.quickAddTarget)
    mixpanel.track("Quick Add to Try-on")
  }

  showQuickAddTooltip(quickAdd) {
    if (isFirstCardOnPage(this.element) && isVisible(quickAdd)) {
      return true
    }
  }
}
